/* eslint-disable no-multi-spaces */
/* eslint-disable key-spacing */
import get from "lodash/get";

import {
  UPDATE_PROPS,
  GO_TO_ADD_ASSET,
  GO_TO_INDEX,
  BACK,
  DELETE_ASSET,
  UNLINK_ASSET,
  UPDATE_ASSET,
  SET_ASSET_TYPE_TO_CREATE,
  CONFIRM_DELETE,
  CONFIRM_UNLINK,
  SUBMIT_FORM,
  LOADING,
  MUTATION_FAILED,
  SET_ASSET_VIEW,
} from "./actions";

import { formFieldsInGroupsForAssetType } from "./utils/formFieldsForAssetType";
import { humanizeString } from "../../utils/stringMinipulation";
import supportedAssets from "./mockData/supportedAssets.json";

export const SCREEN_STATES = {
  INDEX: "index",
  CREATE: "create",
  DESTROY: "destroy",
  FORM: "form",
  UNLINK: "unlink",
};

export default function reducer(state, { type, payload }) {
  switch (type) {
    case UPDATE_PROPS:
      const currentlyOnForm = state.screen === SCREEN_STATES.FORM;
      const groupedFormFields = currentlyOnForm
        ? formFieldsInGroupsForAssetType(
            // A new asset is `{}`, not null, so it carries no type of its own.
            { asset_type: state.formAssetType },
            payload.props.scenario.isRetired
          )
        : null;

      return {
        ...state,
        assets: payload.props.assets,
        isRetired: payload.props.scenario.isRetired,
        groupedFormFields,
      };
    case GO_TO_ADD_ASSET:
      return {
        ...state,
        cameFrom: state.screen,
        screen: SCREEN_STATES.CREATE,
        title: "Choose the type of asset you want to add",
        isExistingAsset: true,
        supportedAssets,
      };
    case GO_TO_INDEX:
      return {
        ...state,
        error: null,
        loading: false,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        title: "Assets you currently have",
        asset: {},
      };
    case BACK:
      const asset =
        (state.parentAsset?.id ? state.parentAsset : null) ||
        (state.asset?.id ? state.asset : null) ||
        (state.formAssetType ? { asset_type: state.formAssetType } : null);
      return {
        ...state,
        error: null,
        loading: false,
        screen: state.cameFrom,
        asset: state.parentAsset || state.asset,
        parentAsset: null,
        cameFrom:
          state.cameFrom === SCREEN_STATES.FORM
            ? SCREEN_STATES.INDEX
            : state.screen,
        formAssetType: asset?.asset_type,
        title: asset ? humanizeString(asset.asset_type) : state.title,
        groupedFormFields: asset
          ? formFieldsInGroupsForAssetType(asset, state.isRetired)
          : state.groupedFormFields,
        isExistingAsset: !get(asset, `new`, false),
      };
    case DELETE_ASSET:
      return {
        ...state,
        screen: SCREEN_STATES.DESTROY,
        cameFrom: state.screen,
        asset: payload.asset,
        modalScrollTop: payload.scrollTop,
      };
    case UNLINK_ASSET:
      return {
        ...state,
        screen: SCREEN_STATES.UNLINK,
        cameFrom: state.screen,
        asset: payload.asset,
        modalScrollTop: payload.scrollTop,
      };
    case UPDATE_ASSET:
      return {
        ...state,
        screen: SCREEN_STATES.FORM,
        cameFrom: state.screen,
        asset: { ...payload.asset },
        parentAsset: { ...state.asset },
        formAssetType: payload.asset.asset_type,
        title: humanizeString(payload.asset.asset_type),
        groupedFormFields: formFieldsInGroupsForAssetType(
          payload.asset,
          state.isRetired
        ),
        isExistingAsset: !get(payload.asset, `new`, false),
        submitLabel: "update asset",
        deleteLabel: "delete asset",
        backLabel: "back",
      };
    case SET_ASSET_TYPE_TO_CREATE:
      return {
        ...state,
        screen: SCREEN_STATES.FORM,
        cameFrom: state.screen,
        title: humanizeString(payload.assetType),
        asset: {},
        formAssetType: payload.assetType,
        groupedFormFields: formFieldsInGroupsForAssetType(
          { asset_type: payload.assetType },
          state.isRetired
        ),
        submitLabel: "add asset",
        deleteLabel: "back to assets",
        backLabel: "back",
      };
    case SET_ASSET_VIEW:
      return {
        ...state,
        assetView: payload.assetView,
      };

    case CONFIRM_DELETE:
      return {
        ...state,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        loading: false,
        asset: {},
      };
    case CONFIRM_UNLINK:
      return {
        ...state,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        loading: false,
        asset: {},
      };
    case SUBMIT_FORM:
      return {
        ...state,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        loading: false,
      };
    case LOADING:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case MUTATION_FAILED:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };
    default:
      return { ...state };
  }
}

export const propsToState = (props) => ({
  screen: SCREEN_STATES.INDEX,
  cameFrom: SCREEN_STATES.INDEX,
  title: "Assets you currently have",
  loading: false,
  error: null,
  asset: {},
  isExistingAsset: true,
  formAssetType: null,
  submitLabel: null,
  deletelLabel: null,
  backLabel: null,
  groupedFormFields: null,
  isRetired: props.scenario.isRetired,
  supportedAssets,

  // NOTE: We need to decouple assets from props
  assets: props.assets,
});
